import React from 'react';
import useLDflexList from '../hooks/useLDflexList';
/** Displays a list of items matching a Solid LDflex expression. */

export default function List(_ref) {
  var src = _ref.src,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset,
      _ref$limit = _ref.limit,
      limit = _ref$limit === void 0 ? Infinity : _ref$limit,
      _ref$filter = _ref.filter,
      filter = _ref$filter === void 0 ? function () {
    return true;
  } : _ref$filter,
      _ref$container = _ref.container,
      container = _ref$container === void 0 ? function (items) {
    return (/*#__PURE__*/React.createElement("ul", null, items)
    );
  } : _ref$container,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? function (item, index) {
    return (/*#__PURE__*/React.createElement("li", {
        key: index
      }, "".concat(item))
    );
  } : _ref$children;
  var items = useLDflexList(src).filter(filter).slice(offset, +offset + +limit).map(children);
  return container ? container(items) : items;
}